import { format } from "date-fns";
import I18n from "components/materials/I18n";
import { dateFnsLocal } from "components/materials/I18n/I18nStore";

export const formatDate = (locale: string, date: Date) => {
	return date.toLocaleDateString(locale, { day: "numeric", month: "long", year: "numeric" });
};

export const formatDateTime = (date: Date) => {
	return format(new Date(date), "PPPp", { locale: dateFnsLocal[I18n.getLocale()] });
};

export const utcToZonedTime = (date: Date) => {
	return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
};

export const formatDateForDateTimeLocal = (date: string | Date): string => {
	const d = typeof date === "string" ? new Date(date) : date;
	const timezoneOffset = d.getTimezoneOffset();
	const localDate = new Date(d.getTime() - timezoneOffset * 60000);
	return localDate.toISOString().slice(0, 16); // YYYY-MM-DDTHH:MM
};
